import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { useConfig } from '@modules/config/composables';
import { buildObjectFromArray } from '@utils/object';

const companyKeys = {
  tab_name: 'TAB_NAME',
  company_name: 'COMPANY_NAME',
  max_trackers: 'MAX_TRACKERS',
  deafult_creative_id: 'DEFAULT_CREATIVE_ID',
  default_advertising_company_id: 'DEFAULT_ADVERTISING_COMPANY_ID',
  deafult_serial_id: 'DEFAULT_SERIAL_ID',
  default_condition: 'DEFAULT_CONDITION',
  default_subaffiliate_condition: 'DEFAULT_SUBAFFILIATE_CONDITION',
  title: 'TITLE',
  currency: 'CURRENCY',
  header_color: 'HEADER_COLOR',
  buttons_color: 'BUTTONS_COLOR',
  default_language: 'DEFAULT_LANGUAGE',
  project_languages: 'PROJECT_LANGUAGES',
  creative_languages: 'CREATIVE_LANGUAGES',
};

function generateCompanyKeys(): Record<string, string> {
  const { config } = useConfig();
  const arr: string[] = [];
  Array.from(Array.from({ length: config.value?.default_domains_count_for_creatives ?? 0 })).forEach((a, i) => {
    const name = 'creative_default_domain';
    if (i === 0) {
      arr.push(name);
    } else {
      arr.push(`${name}${i + 1}`);
    }
  });
  return {
    ...buildObjectFromArray(arr, ''),
    ...companyKeys,
  };
}

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            company: generateCompanyKeys(),
          },
        },
      },
    },
  }));
}
